import { render, staticRenderFns } from "./forgetPwd.vue?vue&type=template&id=7c1a5e64&scoped=true"
import script from "./forgetPwd.vue?vue&type=script&lang=js"
export * from "./forgetPwd.vue?vue&type=script&lang=js"
import style0 from "./forgetPwd.vue?vue&type=style&index=0&id=7c1a5e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1a5e64",
  null
  
)

export default component.exports